import script from "./InvoicesTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicesTableRow.vue?vue&type=script&setup=true&lang=js"

import "./InvoicesTableRow.vue?vue&type=style&index=0&id=7066ece0&scoped=true&lang=css"
script.__scopeId = "data-v-7066ece0"

export default script